import { usePathname } from 'next/navigation';
import { FC, useState } from 'react';
import Heading from '~/components/heading';
import Icon from '~/components/icon';
import AppModal from '~/components/modal';
import WYSIWYGContent from '~/components/wysiwyg-content';
import BlockCustomerForm from '~/data/strapi/types/shared-blocks/block-customer-form';
import CustomerForm from '~/features/customer-form';
import CustomerFormAcceptModal from '~/features/customer-form/accept-modal';

import styles from './styles.module.css';

interface Props {
  visible: boolean;
  onClose: () => void;
  customerFormData: BlockCustomerForm;
  serviceName?: string;
}

const CustomerFormModal: FC<Props> = ({ visible, onClose, customerFormData, serviceName }) => {
  const { modal, successModal } = customerFormData;

  const [showConfimation, setShowConfirmation] = useState<boolean>(false);
  const pathname = usePathname();

  const showConfirmModal = () => {
    window.history.replaceState({}, '', `${pathname}#modalFormSuccess`);
    setShowConfirmation(true);
  };

  const closeConfirmation = () => {
    setShowConfirmation(false);
    onClose();
  };
  if (!modal) return null;

  const { description, heading, buttonTitle, agreementText } = modal;

  if (showConfimation && successModal)
    return <CustomerFormAcceptModal onClose={closeConfirmation} visible={visible} data={successModal} />;

  return (
    <AppModal visible={visible} onClose={onClose}>
      <article className={styles.container}>
        <button className={styles.closeBtn} onClick={onClose}>
          <Icon name="close" className={styles.icon} />
        </button>
        <div className={styles.headingContainer}>
          {heading && <Heading data={heading} className={styles.heading} />}
          {description && <WYSIWYGContent className={styles.description} html={description} />}
        </div>
        <CustomerForm
          className={styles.form}
          onSuccess={showConfirmModal}
          buttonTitle={buttonTitle}
          agreementText={agreementText}
          serviceName={serviceName}
        />
      </article>
    </AppModal>
  );
};

export default CustomerFormModal;
